import React from 'react';
import SimpleReportForm from '../SimpleReportForm';
import GenericSurepassOutputComponent from '../output/GenericSurepassOutputComponent';

const ItrSubmitOtpInputComponent = () => (
    <SimpleReportForm
        banner={{ icon: 'pi-check-circle', title: 'ITR Submit OTP', subtitle: 'Verify OTP received from the Income Tax portal for an ITR client' }}
        fields={[
            { name: 'client_id', label: 'Client ID', icon: 'pi-key', placeholder: 'itr_xxxxxxxxxxxxx', maxLength: 100, mono: true },
            { name: 'otp', label: 'OTP', icon: 'pi-lock', placeholder: '6-digit OTP', maxLength: 6, inputMode: 'numeric', numeric: true, autoComplete: 'one-time-code', mono: true,
              regex: /^\d{4,8}$/, regexError: 'Enter a valid OTP', colClass: 'col-12 md:col-4' },
        ]}
        endpoint={{
            path: '/surepass/itr/submit-otp',
            bodyMapper: (v, sid) => ({ client_id: v.client_id.trim(), otp: v.otp, api_provider_service_id: parseInt(sid, 10) }),
        }}
        consentReportType="itr-submit-otp"
        submitLabel="Verify OTP"
        successSummary="ITR OTP verified"
        errorSummary="OTP verification failed"
        confirmHeader="Confirm ITR OTP verification"
        confirmAcceptLabel="Yes, verify"
        outputComponent={GenericSurepassOutputComponent}
        outputProps={{ title: 'ITR OTP Verified', icon: 'pi-check-circle' }}
    />
);

export default ItrSubmitOtpInputComponent;
